import { AxiosResponse } from 'axios';

// Helper.
import API from '../Api';
// Types.
import { HubSpotDB } from '../types/faq';

export const fetchFaqs = async (): Promise<HubSpotDB[]> => {
  const faqs: AxiosResponse<HubSpotDB[]> = await API({
    method: 'get',
    url: `/v1/faqs`,
  });

  return faqs.data;
};
